import styled from 'styled-components'

export const AutocompleteContainer = styled.div`
	position: relative;
	width: 100%;
`

export const Input = styled.input`
	width: 100%;
	padding: 0.625rem 2.5rem 0.625rem 0.75rem;
	border: 1px solid #d1d5db;
	border-radius: 6px;
	font-size: 0.875rem;
	outline: none;
	transition: border-color 0.2s, box-shadow 0.2s;

	&:focus {
		border-color: #f97316;
		box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const ClearButton = styled.button`
	position: absolute;
	right: 0.75rem;
	top: 50%;
	transform: translateY(-50%);
	background: none;
	border: none;
	color: #9ca3af;
	font-size: 1.5rem;
	line-height: 1;
	cursor: pointer;
	padding: 0.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 1.5rem;
	height: 1.5rem;
	border-radius: 50%;
	transition: background-color 0.15s, color 0.15s;
	will-change: auto;

	&:hover {
		background-color: #f3f4f6;
		color: #374151;
		transform: translateY(-50%);
	}

	&:focus {
		outline: 2px solid #f97316;
		outline-offset: 2px;
	}
`

export const AutocompleteDropdown = styled.div<{ $top: number; $left: number; $width: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	width: ${({ $width }) => $width}px;
	background: white;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
	max-height: 300px;
	overflow-y: auto;
	z-index: 10000;
`

export const AutocompleteItem = styled.div`
	padding: 0.75rem 1rem;
	cursor: pointer;
	transition: background-color 0.15s;

	&:hover {
		background-color: #fef3c7;
	}

	&:not(:last-child) {
		border-bottom: 1px solid #f3f4f6;
	}
`

export const EmptyAutocompleteItem = styled(AutocompleteItem)`
	cursor: default;
	color: #9ca3af;
`

export const MainText = styled.div`
	font-size: 0.875rem;
	font-weight: 500;
	color: #111827;
	margin-bottom: 0.125rem;
`

export const SecondaryText = styled.div`
	font-size: 0.75rem;
	color: #6b7280;
`
